/*!
 * exampleHeader.js — a Live example's title and what it is, from its first line
 * © 2026 Rob Canning — GPLv3
 *
 * Every example opens "// Title: what it is" (public/live-examples/); the
 * examples list shows the two (liveExamples.js listExamples). Pure.
 */

/** "// Noise wall: brown noise through ..." -> { title: "Noise wall", about: "brown noise through ..." }. */
export function exampleHeader(code, file = "") {
  const first = String(code ?? "").split("\n").find(l => l.trim()) || "";
  const m = /^\s*\/\/\s*([^:]{1,40}):\s*(.*)$/.exec(first);
  const fallback = file.replace(/\.txt$/, "").replace(/-/g, " ").replace(/^./, c => c.toUpperCase());
  return m ? { title: m[1].trim(), about: m[2].trim() } : { title: fallback, about: "" };
}
